export default {
  admin: {
    invoice: {
      title: "Facturation — Codification comptable",
      tab: {
        payers: "Tiers payeurs",
        sequence: "Chrono pièces comptables",
        article_codes: "Codes articles",
        terms_of_payment: "Conditions de paiement",
        bank_details: "Données bancaires",
      },
      alert: {
        locked: "Paramétrage verrouillé par l'administrateur de la plateforme",
        payer:
          "Ces valeurs sont héritées par chaque entreprise à sa création. Elles restent modifiables individuellement sur la fiche entreprise.",
        article_code:
          "Le code est verrouillé et non modifiable. Tous les autres champs sont personnalisables — cliquez sur le crayon pour éditer une ligne.",
        payment_code:
          "Ces référentiels alimentent les écritures comptables transmises à Sage. Codes définis par l'équipe STUDEA — non modifiables.",
        bank_details:
          "Informations confidentielles — transmises à l'API Convergence et affichées sur les pièces comptables.",
        sequence_info:
          "Plusieurs types de financeurs ne peuvent pas partager le même chrono. Activez les types concernés sur chaque bloc.",
      },
      sequence: {
        add: "Ajouter un chrono",
        add_success: "Chrono ajouté avec succès !",
        add__confirm: "Êtes-vous sûr de vouloir ajouter un chrono ?",
        update_success: "Donnée mise à jour avec succès !",
        stats: {
          invoices: "Factures émises",
          credits: "Avoirs émis",
          anomalies: "Anomalies chrono",
        },
      },
      payers: {
        actions: {
          apply_collective_account: {
            title: "Appliquer le compte collectif",
            subtitle: "Aux entreprises privées sans compte défini",
            subtitle_public: "Aux entreprises publiques sans compte défini",
          },
          payment_terms: {
            title: "Appliquer les conditions de règlement",
            subtitle: "Aux entreprises privées sans conditions définies",
            subtitle_public: "Aux entreprises publiques sans conditions définies",
          },
          missing_subsidiary_ledgers: {
            title: "Générer les comptes auxiliaires manquants",
            subtitle: "Les numéros existants ne seront pas écrasés",
          },
        },
        update: {
          success: "Donnée mise à jour avec succès !",
        },
        apply: {
          success: "{count} entreprise(s) mise(s) à jour",
          opco: {
            success: "{count} OPCO(s) mis à jour",
          },
        },
      },
      article_code: {
        edit: {
          success: "Code article modifié avec succès !",
        },
      },
      action: {
        deactivate: "Désactiver",
        activate: "Activer",
      },
      payment_code: {
        activated: {
          success: ({ plural }) => plural(["Code désactivé avec succès !", "Code activé avec succès !"]),
        },
        toggle_error: "Erreur lors de la mise à jour des données affichées, veuillez rafraîchir la page",
      },
      bank_details: {
        success: "Données bancaires modifiées avec succès !",
      },
    },
    help_settings: "Paramètres de l'aide",
    help_settings_success: "Paramètres de l'aide modifiés avec succès !",
    lastEmail: "Lien du dernier mail envoyé",
    generatePassword: "Régénérer et envoyer le mot de passe",
    switchUser: "Incarner {name}",
    switchAdmin: "Vous incarnez",
    switchAdminLabel: "Admin",
    switchPilot: "Pilote",
    modify: "Modifier {title}",
    show: "Voir {title}",
    delete: "Supprimer {title}",
    add: "Ajouter",
    name: "Nom",
    title: "Titre",
    year: "Année",
    trainingOpeningStart: "Début des ouvertures de la formation",
    trainingOpeningEnd: "Fin des ouvertures de la formation",
    level: "Niveau",
    registrationDate: "Date d'enregistrement",
    active: "Actif",
    activateOption: "Activer/Désactiver",
    management_of: "Gestion des",
    contents: "contenus",
    users: "Utilisateurs",
    trainings: "Formations",
    archiving: {
      title: "Archivage",
      action: "Archiver",
      archive_confirmation: "Êtes-vous sûr de vouloir archiver ces promotions ?",
      active_confirmation: "Êtes-vous sûr de vouloir désarchiver ces promotions ?",
      archive_success: "Promotions archivées avec succès !",
      active_success: "Promotions désarchivés avec succès !",
    },
    current_training_course_year: {
      title: "Modifier l'année en cours",
      error: "L'année de référence doit être différente de la nouvelle année en cours",
      confirmation: {
        title: "Êtes-vous sûr de vouloir changer l'année en cours",
        subtitle: "Elle sera modifiée sur toutes les promotions qui ont pour année de début l'année de référence",
      },
      success: ({ named }) => `Année en cours changée sur ${named("count")} promotions`,
    },
    livretConfig: {
      title: "Activation du livret",
      confirmation: "Êtes-vous sûr de vouloir modifier ces données ?",
      success: "Configuration du livret enregistrée avec succès !",
    },
    modules: "Modules",
    module: "Module",
    code: "Code",
    error: "Une erreur s'est produite, veuillez réessayer plus tard !",
    lastName: "Nom",
    firstName: "Prénom",
    profile: "Profil",
    embody: "Incarner",
    visible: "Visible",
    popup: "Popup",
    visibleHomeLea: "Visible",
    endDate: "Date de fin",
    startDate: "Date de début",
    contractTypeColor: "Couleur du contrat",
    none_duplicated_user: "Aucun utilisateur à fusionner",
    skill: {
      title: ({ plural }) => plural(["Compétence", "Compétences"]),
    },
    skillCategory: {
      title: "Catégorie",
    },
    skill_session: {
      generate: "Générer des périodes",
      empty:
        "Vous devez renseigner un nombre de périodes à créer dans la configuration du module avant de pouvoir les configurer",
      generation_success: "Périodes générés avec succès",
      existing_session: "Vous êtes sur le point de supprimer des périodes existantes, êtes vous sûr de votre choix ?",
    },
    skillReferential: {
      title: "Référentiel de compétences",
      edit: "Modifier le référentiel",
    },
    skill_import_france_competence: {
      title: "Importer tous les référentiels France Compétences",
      confirm: "Êtes-vous sûr de vouloir charger tous les référentiels France Compétences ?",
      success: "Référentiels importés avec succès !",
    },
    navigation: {
      users: "Utilisateurs",
      trainings: "Formations",
      modules: "Modules",
      settings: "Paramétrage",
      general: "Général",
      steering: "Pilotage",
    },
    home: {
      title: "Configuration générale",
      title2: "Vue d'ensemble",
      title3: "Synchronisation automatique",
      title4: "Statistiques générales",
      active: "Activé",
      unique_connection: "connexion unique",
      apprentices_mentor: "Apprentices and mentors",
    },
    log: {
      title: ({ plural }) => plural(["Log", "Logs"]),
      view: "Voir les données modifiées",
      modify_field: "Champ modifié",
      old_data: "Ancienne donnée",
      data: "Nouvelle donnée",
      impersonation_chain: "Chaîne d'usurpation",
      impersonator_type: {
        zama: "Administrateur Zama",
        studea: "Administrateur Studea",
        studea_admin: "Administrateur Studea",
        studea_manager: "Responsable Studea",
      },
    },
    ypareoReporting: {
      title: ({ plural }) => plural(["Rapport Ypareo", "Rapports Ypareo"]),
      view: "Voir le rapport",
    },
    edusignReporting: {
      title: ({ plural }) => plural(["Rapport Edusign", "Rapports Edusign"]),
      view: "Voir le rapport",
    },
    registrationAlert: {
      title: ({ plural }) => plural(["Alerte", "Alertes"]),
    },
    ammonReporting: {
      title: ({ plural }) => plural(["Rapport Ammon", "Rapports Ammon"]),
      view: "Voir le rapport",
    },
    ggeReporting: {
      title: ({ plural }) => plural(["Rapport GGE", "Rapports GGE"]),
      view: "Voir le rapport",
    },
    ssoReporting: {
      title: ({ plural }) => plural(["Rapport SSO", "Rapports SSO"]),
      view: "Voir le rapport",
    },
    ofalinkReporting: {
      name: "Ofa Link",
      title: ({ plural }) => plural(["Rapport Ofa Link", "Rapports Ofa Link"]),
      view: "Voir le rapport",
    },
    report: {
      title: ({ plural }) => plural(["Rapport", "Rapports"]),
      view: "Voir le rapport",
    },
    mail: {
      title: ({ plural }) => plural(["Mail", "Mails"]),
      view: "Voir le contenu du mail",
      recipient: "Destinataire :",
      status: "Statut d'envoi :",
      sent_on: "Envoyé le :",
      open_on: "Ouvert le :",
      error_message: "Message d'erreur",
      no_error_message: "Le serveur n'a renvoyé aucun message.",
    },
    registrationField: {
      title: ({ plural }) => plural(["Champ", "Champs"]),
    },
    registrationBlock: {
      title: ({ plural }) => plural(["Bloc", "Blocs"]),
    },
    registrationTab: {
      title: ({ plural }) => plural(["Onglet", "Onglets"]),
    },
    registrationStep: {
      title: ({ plural }) => plural(["Étape", "Étapes"]),
    },
    registrationDataVersion: {
      title: ({ plural }) => plural(["Version", "Versions"]),
      notEmpty: "Des fiches sont déjà rattachées à cette version",
    },
    registrationDevice: {
      title: ({ plural }) => plural(["Dispositif", "Dispositifs"]),
    },
    registrationDataConfiguration: "Modifer le paramétrage de la version",
    cerfaParam: {
      title: ({ plural }) => plural(["Paramétrage Cerfa", "Paramétrages Cerfa"]),
    },
    role: {
      title: ({ plural }) => plural(["Rôle", "Rôles"]),
    },
    triad: {
      title: ({ plural }) => plural(["Trinôme", "Trinômes"]),
      delete_all_triad: {
        title: "Supprimer tous les trinômes",
        confirmation: "Êtes-vous sûr de vouloir supprimer tous les trinômes de cette promotion ?",
        success: "Trinômes supprimés avec succès !",
      },
    },
    studeaUser: {
      title: ({ plural }) => plural(["Utilisateur", "Utilisateurs"]),
    },
    user: {
      title: ({ plural }) => plural(["Utilisateur", "Utilisateurs"]),
      actions: {
        keep_user: "Garder",
        delete_user: "Supprimer",
        unselect_user: "Déselectionner cet utilisateurs",
        reset_password: {
          success: "Le lien de réinitialisation du mot de passe a été envoyé avec succès à l'utilisateur !",
        },
      },
      add_profile: "Ajouter un profil",
      warning_profile: "Suppression d'un profil",
      warning_profile_text: "Êtes-vous sûr de vouloir supprimer ce profil ?",
      last_connection: "Dernière connexion le : \n",
      search_user_by_name_or_mail: "Rechercher un utilisateur par nom ou email",
      import_users: "Importer des utilisateurs",
      profile_config: "Configuration des profils",
      merge: "Fusion des utilisateurs",
      duplicated_user_count: "utilisateurs dupliqués à fusionner",
      merge_duplicated_user_confirmation: "Êtes vous sur de vouloir fusionner ces utilisateurs ?",
      merge_success: "Fusion effectuée avec succès",
      no_double_user: "Aucun doublon trouvé",
      mail_address: "Adresse mail",
      already_connected: "S'est déjà connecté au livret",
      yes: "Oui",
      no: "Non",
      row: "Ligne",
      reference_user: "Utilisateur référence",
      duplicated_user: "Doublons",
      reset_choices: "Réinitialiser les choix",
      options: "Options",
      account_creation: "Création du compte",
      username: "Identifiant",
      external_id: "ID externe",
      birth_date: "Date de naissance",
      send_credential_back_to_user: "Renvoyer les identifiants à l'utilisateur concerné",
      reference_user_is_not_duplicate: "L'utilisateur référence n'est pas un doublon",
      keep: "Garder",
      delete: "Supprimer",
      export: "Exporter",
      send: "Enregistrer",
      profile_title: "Libellés des profils utilisateur",
      users_profile_title_list: "Liste des libellés des profils utilisateur",
      modify_profile: "Modification du libellé",
      modification_succes: "Profile modifié avec succès",
      no_mail_title: "Aucun lien",
      no_mail: "Cet utilisateur n'a pas encore reçu de lien de réinitialisation de son mot de passe !",
      profile_user_info:
        "Créer les différents profils pilotes avec des droits spécifiques que l’on pourra rattacher par la suite aux utilisateurs. Exemple : Gestionnaire assiduité, responsable pédagogique, ….",
      role: {
        NONE: "Non",
        ALL: "Oui",
        VIEW: "Voir",
        EDIT: "Modifier",
        DELETE: "Supprimer",
      },
      erase_studeaManager_profile:
        "Attention, vous êtes sur le point de supprimer le(s) profil(s) pilote rattachés à votre compte",
    },
    profile_label: {
      titleAbbreviation: "Abréviation",
      titlePlural: "Titre au pluriel",
      titleWithArticle: "Titre avec l'article",
    },
    training: {
      title: ({ plural }) => plural(["Formation", "Formations"]),
      ufa_add_test: "Créer une formation test",
      genere_triad_test: "Générer des trinômes test",
      generate_triad_test_confirmation: "Êtes-vous sûr de vouloir créer des trinômes test sur toutes les formations ? ",
      genere_triad_test_success: "Les trinômes test ont été crées avec succès !",
      genere_training_test_success: "La formation test a été crée avec succès !",
      import_triad: "Importer des trinômes",
      confirmation_subtitle:
        "Cette suppression entrainera également la suppression des promotions reliées à cette formation",
    },
    variable: {
      title: ({ plural }) => plural(["Variable", "Variables"]),
    },
    modele: {
      title: ({ plural }) => plural(["Modèle", "Modèles"]),
    },
    registration: {
      title: ({ plural }) => plural(["Inscription", "Inscriptions"]),
    },
    trainingCourse: {
      title: ({ plural }) => plural(["Promotion", "Promotions"]),
      duplicate_on_next_year: "Dupliquer la promotion sur l'année suivante",
      duplicate: "Dupliquer la promotion",
      delete: "Supprimer la promotion",
    },
    copy: {
      success: ({ plural, named }) =>
        plural([`${named("name")} copié avec succès !`, `${named("name")} copiée avec succès !`]),
      title: ({ plural, named }) => plural([`Copier ce ${named("name")}`, `Copier cette ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Êtes-vous sûr de vouloir copier ce ${named("name")}`,
          `Êtes-vous sûr de vouloir  copier cette ${named("name")}`,
        ]),
      error: ({ plural, named }) =>
        plural([
          `Une erreur est survenue lors de la copie de ce ${named("name")}`,
          `Une erreur est survenue lors de la copie de cette ${named("name")}`,
        ]),
    },
    studeaManager: {
      title: ({ plural }) => plural(["Pilote", "Pilotes"]),
    },
    design: {
      title: "Habillage",
    },
    dataAgreement: {
      title: ({ plural }) => plural(["Politique des données", "Politiques des données"]),
    },
    institution: {
      title: ({ plural }) => plural(["Établissement", "Établissements"]),
      list: {
        title: "Les établissements actifs",
      },
      export: {
        booklets: "Export des livrets de l'établissement",
        answers: "réponses aux questionnaires de l'année précédente",
      },
    },
    document: {
      title: ({ plural }) => plural(["Document public", "Documents publics"]),
    },
    documentCategory: {
      title: ({ plural }) => plural(["Catégorie de document", "Catégories de document"]),
    },
    helpDocument: {
      title: ({ plural }) => plural(["Aide en ligne", "Aides en ligne"]),
    },
    component: {
      title: ({ plural }) => plural(["Composante", "Composantes"]),
      export: {
        title: "réponses aux questionnaires de l'année précédente",
      },
    },
    degree: {
      title: ({ plural }) => plural(["Type de diplôme", "Types de diplôme"]),
    },
    contractType: {
      title: ({ plural }) => plural(["Type de contrat", "Types de contrat"]),
    },
    planContract: {
      title: ({ plural }) => plural(["Année de formation", "Années de formation"]),
      actions: {
        activate: {
          title: "Activer",
          success: "Année de formation activée avec succès !",
        },
        activate_recruitment: {
          title: "Activer pour le recrutement",
          success: "Activée pour le recrutement avec succès !",
        },
      },
    },
    titleRncp: {
      title: ({ plural }) => plural(["Titre RNCP", "Titres RNCP"]),
    },
    modulet: {
      title: ({ plural }) => plural(["Module", "Modules"]),
      list: {
        title: "Gestion des modules",
      },
      trainingCourse: {
        edit: {
          title: "Modifier les formations rattachées au module",
          success: "Formations rattachées au module modifées avec succès !",
        },
        displayActive: "Afficher uniquement les formations rattachés au module",
      },
      config: {
        title: "Configuration du module",
      },
      skill_session: {
        title: "Générer des périodes",
      },
      registration: {
        title: "Tableau de bord des inscriptions",
      },
      skill_referential: {
        title: "Référentiel de compétences",
        list: "Les référentiels",
        edit: "Modification du référentiel",
        config: "Configuration du module",
      },
    },
    template: {
      title: ({ plural }) => plural(["Modèle", "Modèles"]),
      success: "Modèle modifié avec succès !",
      duplicate: "Dupliquer ce modèle",
      default_template: "Modèle par défaut",
    },
    absenceReason: {
      title: ({ plural }) => plural(["Motif d'absence", "Motifs d'absence"]),
    },
    questionnaireConfig: {
      title: "Configuration du module questionnaire",
      multiple_actions: "Modification des questionnaires",
      action_to_do: "Actions à réaliser",
      warning:
        "Cette action entrainera la modification de tous les questionnaires de l'année selectionnée ayant pour titre le titre selectionné. Les champs laissés vides ne seront pas modifiés",
      confirmation: "Êtes-vous sûr de vouloir modifier ces données ?",
      success: "Questionnaires modifiés avec succès !",
    },
    ypareoConfig: {
      title: "Configuration du module Ypareo",
      get_directories: "Récupérer les répertoires ypareo",
      reference_tables: {
        tab_title: "Tables de référence",
        intro:
          "Ces tables sont récupérées une fois depuis Yparéo et stockées dans Studea, pour que la synchronisation d'un dossier n'ait plus besoin d'interroger Yparéo à chaque envoi.",
        refresh_button: "Rafraîchir depuis Yparéo",
        refresh_success: "Table rafraîchie avec succès",
        mapping_saved: "Correspondance enregistrée",
        last_refreshed_at: "Dernier rafraîchissement : {date}",
        never_refreshed: "Jamais rafraîchie",
        active_count: ({ plural, named }) =>
          plural([`${named("count")} ligne active`, `${named("count")} lignes actives`]),
        show_inactive: "Afficher les lignes inactives",
        code_column: "Code Yparéo (lecture seule)",
        label_column: "Libellé Yparéo (lecture seule)",
        mapping_column: "Correspondance Studea",
        active_column: "Statut",
        active_value: "Active",
        inactive_value: "Inactive",
        no_studea_values:
          "Aucune valeur Studea disponible pour ce référentiel actuellement — la correspondance ne peut pas encore être saisie.",
        read_only_notice:
          "Ce référentiel est consultable et rafraîchissable, mais sa correspondance Studea ne se saisit pas ligne à ligne : elle se fait par combinaison (statut, diplôme, année, redoublant) sur un écran dédié.",
        no_rows: "Aucune ligne pour ce référentiel. Lancez un rafraîchissement pour l'alimenter depuis Yparéo.",
        mapping_aria_label: "Correspondance Studea pour {label}",
        table_caption: "Table de référence {label}",
        types: {
          civility: "Civilité",
          nationality: "Nationalité",
          birth_country: "Pays de naissance",
          school_origin: "Origine scolaire",
          obtained_degree: "Diplôme obtenu",
          employer_type: "Type d'employeur",
          situation: "Situation",
        },
      },
      exclusion_refresh: {
        intro:
          "Ces listes sont récupérées une fois depuis Yparéo et stockées dans Studea, pour alimenter les filtres d'exclusion de l'onglet ci-dessous.",
        refresh_button: "Rafraîchir depuis Yparéo",
        refresh_success: "Liste rafraîchie avec succès",
        last_refreshed_at: "Dernier rafraîchissement : {date}",
        never_refreshed: "Jamais rafraîchie",
        active_count: ({ plural, named }) =>
          plural([`${named("count")} ligne active`, `${named("count")} lignes actives`]),
        types: {
          status: "Statuts",
          group: "Groupes",
        },
      },
      exclusion_list: {
        add_button: "Ajouter une exclusion",
        empty: "Aucune exclusion enregistrée",
        code_column: "Code",
        label_column: "Libellé",
        delete_button: "Supprimer {code}",
        delete_confirm_title: "Retirer cette exclusion ?",
        delete_confirm_subtitle: "Le code {code} sera retiré de la liste.",
        delete_success: "Exclusion retirée avec succès",
        modal_title: "Ajouter une exclusion — {label}",
        add_button_inclusion: "Ajouter une inclusion",
        modal_title_inclusion: "Ajouter une inclusion — {label}",
        empty_inclusion: "Aucune inclusion enregistrée",
        delete_confirm_title_inclusion: "Retirer cette inclusion ?",
        delete_confirm_subtitle_inclusion: "Le code {code} sera retiré de la liste.",
        delete_success_inclusion: "Inclusion retirée avec succès",
        search_label: "Rechercher dans {label}",
        search_placeholder: "Saisir au moins 3 caractères",
        searching: "Recherche en cours...",
        no_result: "Aucun résultat",
        results_found: ({ plural, named }) =>
          plural([`${named("count")} résultat trouvé`, `${named("count")} résultats trouvés`]),
        add_result: "Ajouter {label}",
        add_success: "{label} ajouté avec succès",
        included_group_title: "Codes groupe inclus",
        previous_group_title: "Codes groupe à intégrer malgré leur rattachement à la période précédente",
        excluded_group_title: "Codes groupe exclus",
        excluded_apprentice_title: "Apprentis exclus",
        mode_help: "Le changement de mode ne sera appliqué qu'au prochain enregistrement.",
      },
      school_origin_mapping: {
        intro:
          "Pour chaque code Yparéo, ajoutez les réponses du dossier qui y correspondent : déjà en apprentissage (Oui/Non), un ou plusieurs diplômes préparés et une ou plusieurs dernières classes suivies. Une même combinaison ne peut correspondre qu'à un seul code ; sans correspondance, l'apprenant est envoyé sans origine scolaire et la candidature n'est pas envoyée vers Yparéo.",
        add_button: "Ajouter",
        remove_aria: "Retirer la correspondance {mapping}",
        add_aria: "Ajouter une correspondance au code Yparéo {code}",
        already_apprentice_label: "Déjà apprenti ?",
        degrees_label: "Diplômes",
        classes_label: "Classes",
        delete_confirm_title: "Retirer cette correspondance ?",
        create_success: "Correspondance ajoutée",
        delete_success: "Correspondance retirée",
        ypareo_inactive_warning: "Désactivé côté Yparéo — à corriger",
      },
    },
    driverLicenceConfig: {
      title: "Configuration du module permis B",
    },
    studeaManagerProfile: {
      title: ({ plural }) => plural(["Profil pilote", "Profils pilotes"]),
      all_access: "Activer toutes les permissions",
    },
    historic: {
      title: "Historique",
    },
    statistic: {
      title: "Statistiques",
      general: "Générales",
      questionnaires: "Questionnaires",
      absence: "Absences",
      course: "Suivi de cours",
      global_export: "Exporter les statistiques",
      updated_on: "mis à jour le",
      indicators_generated: "Indicateurs complémentaires en cours de génération",
    },
    export: {
      title: "Les exports",
      year: "Les promotions",
      available_exports: "Exports disponibles",
      signature_questionnaire_all: "Exporter les signatures des questionnaires de toutes les formations",
      absence_cumulate_by_diploma: "Exporter le cumul des absences par formation",
      absence_by_apprentice: "Exporter les absences par apprenti",
      company_visits: "Exporter les visites en entreprise",
      contract: "Exporter les contrats",
      dashboard: "Exporter tableau de bord de suivi",
      summary_table: "Exporter tableau récapitulatif",
      questionnaire: "Exporter un questionnaire",
      questionnaire_code_count: "Exporter le nombre de questionnaires par code",
      category_questionnaires: "Questionnaires",
      category_absences: "Absences",
      category_contracts: "Contrats",
      category_general: "Général",
      category_reversibility: "Réversibilité",
      year_filter_hint: "Ce filtre s'applique uniquement aux exports marqués de ce pictogramme calendrier",
      year_filter_badge_tooltip: "Cet export tient compte de l'année sélectionnée ci-dessus",
      reversibility: "Exporter les livrets, compétences et absences",
      reversibility_hint:
        "Archive unique organisée par institution puis par promotion : livrets d'apprentissage en PDF avec leurs pièces jointes, évaluations de compétences en PDF, absences au format Excel. Un manifeste détaille le contenu réellement produit. Traitement long.",
      reversibility_confirm_title: "Lancer l'export de réversibilité ?",
      reversibility_confirm_text:
        "Cette action génère une archive de plusieurs gigaoctets et peut prendre plusieurs heures. Ne la lancez qu'au départ définitif du client.",
      reversibility_error: "L'export de réversibilité a échoué. Réessayez plus tard.",
    },
    duplicate: {
      title: "Duplications",
    },
    archive: {
      title: "Archivage",
    },
    news: {
      title: ({ plural }) => plural(["Actualité", "Actualités"]),
      news_list: "Liste des actualités",
      list: {
        title: "Actualités",
        uploaded_date: "Mise en ligne le",
        see_more: "Voir plus",
        see_all_news: "Retrouvez l'ensemble des actus",
        go_back_newslist: "Retour à la liste des actualités",
      },
    },
    import: {
      modele: "Modèle de fichier à télécharger",
      triad_new_file:
        "Attention, un nouveau modèle est disponible depuis le 18/09/2023.\n" +
        "          Merci de le télécharger et de l'utiliser pour charger vos trinômes.",
      triad_update:
        "Attention, seuls les membres manquants d'un trinôme seront mis à jour. Aucune donnée (nom, prénom ou email) d'un utilisateur existant ne sera mise à jour.",
      thanks: "Merci de ne pas modifier et / ou supprimer les colonnes du modèle",
      contract_type_id: "ID types de contrat (colonne AM)",
    },
    text: "Texte",
    dateToDisplay: "Date à afficher",
    emailContent: "Contenu e-mail",
    picture: "Image",
    subTitle: "Sous-titre",
    tag: "Tag",
    video: "Vidéo",
    activate_notification: "Activer les notifications",
    activate_notification_success: "Préférence de notification mise à jour",
    tutorial: {
      title: ({ plural }) => plural(["Tuto Studea", "Tutos Studea"]),
      admin: "Admin",
      studea_manager: "Pilote",
      user: "Utilisateur",
    },
    ammonConfig: {
      title: "Configuration du module Ammon",
      synchronisation: "Synchronisation",
      confirmation: "Êtes-vous sûr de vouloir lancer la synchronisation avec Ammon ?",
    },
    contractRuptureConfig: {
      title: "Déclaration des ruptures de contrat par l'apprenti ou par l'entreprise",
    },
    reporting: {
      list: ({ named }) => `Les rapports ${named("name")}`,
    },
    cfa_config: {
      success: "Configuration du CFA modifiée avec succès !",
    },
    last_report: "Dernier rapport",
    opco: {
      success_update: "OPCO modifié avec succès !",
      synchronisation_confirmation: "Êtes-vous sûr de vouloir synchroniser cet OPCO ?",
      synchronisation_confirmation_subtitle:
        "Vous êtes sur le point de lancer manuellement la synchronisation de l'OPCO {opco}.<br /><br />Une synchronisation automatique s'exécute déjà chaque nuit entre 00h et 03h.<br /><br /> En cas d'appels répétés hors de cette plage horaire, l'OPCO peut suspendre l'accès à son API.<br /><br />Confirmez-vous le déclenchement de la synchronisation ?",
      success_synchronisation: "Synchronisation lancée !",
      api_key: {
        valid: "Clef API CFaDock valide",
        invalid: "Clef API CFaDock invalide",
      },
      error_synchronisation: "Clef API CFaDock invalide",
      invoice: {
        details: "Voir les détails de facturation",
        modal: {
          title: "Détails de facturation de {opco}",
        },
        success_update: "Adresse de facturation modifiée avec succès !",
      },
      files: {
        title: "Dossiers OPCO (3 ans)",
        subtitle: "Tous OPCO confondus",
      },
      sync_files: {
        title: "Dossiers synchronisés",
        subtitle: "de taux de correspondance",
      },
      guide: {
        title: "Guide de lecture",
        baseline: "Comprendre les indicateurs de synchronisation",
        sync_file: {
          title: "Dossier synchronisé",
          description:
            "Studea a relié ce dossier avec son équivalent OPCO. Les données (état, DECA, prise en charge) sont à jour.",
        },
        corresponding: {
          title: "Correspondance probable",
          description:
            "Score 4/5 : un critère ne correspond pas. Le dossier n'est pas lié automatiquement, une confirmation manuelle est requise.",
        },
        progression: {
          title: "Barre de progression",
          description:
            "Dossiers synchronisés / total dossiers OPCO. En orange si un ou plusieurs dossiers sont en attente de confirmation.",
        },
        sync_report: {
          title: "Rapport de synchronisation",
          description:
            "Export XLSX : détail des critères de correspondance (SIRET, RNCP, dates, noms) pour chaque dossier.",
        },
        manual_sync: {
          title: "Synchronisation manuelle",
          description:
            "Réservée aux tests et cas exceptionnels. La synchro automatique s'exécute chaque nuit entre 00h et 03h.",
        },
        inactive: {
          title: "OPCO inactif",
          description: "Connexion non configurée. Contactez votre référent Studea pour l'activer.",
        },
        matching_criteria: {
          title: "Critères de correspondance (score /5)",
          description:
            "Date de naissance de l'alternant · Nom de l'alternant · SIRET de l'entreprise · Date de début de contrat · Code RNCP.<br><strong>5/5</strong> → synchronisation automatique  {'|'}  <strong>4/5</strong> → correspondance probable (confirmation manuelle)  {'|'}  <strong>< 4/5</strong> → pas de correspondance.",
        },
      },
    },
    ia_competences: {
      config_confirmation:
        "Êtes-vous sûr de vouloir appliquer cette configuration IA-Compétences aux promotions sélectionnées ?",
      config_success: "Configuration IA-Compétences appliquée avec succès !",
      reload_error: "Une erreur est survenue lors du rechargement des données.",
      tab_formations: "Formations",
      tab_promotions: "Promotions",
      help_text:
        "Sélectionnez les formations ou promotions à gauche, choisissez les réglages IA à leur appliquer, puis cliquez sur Appliquer.",
      apply: "Appliquer",
      apply_sticky_aria: "Appliquer les réglages IA à la sélection",
      apply_footer_aria: "Appliquer les réglages IA à la sélection",
      features_title: "Fonctionnalités IA",
      module1_title: "Référentiel RNCP",
      module1_label: "Module 1",
      module2_title: "Missions & activités",
      module2_label: "Module 2",
      features_upcoming_title: "Fonctionnalités à venir",
      feature_enrichment: "Enrichissement",
      feature_enrichment_desc: "Suggère des compétences complémentaires à partir du titre RNCP importé.",
      feature_program_breakdown: "Découpage programmes",
      feature_program_breakdown_desc: "Décompose un programme en semestres, unités et modules.",
      feature_matrix: "Matrice UE/Compétences",
      feature_matrix_desc: "Génère la matrice de correspondance UE/compétences du référentiel.",
      feature_mission_breakdown: "Découpage missions",
      feature_mission_breakdown_desc: "Transforme une mission en activités structurées alignées sur le référentiel.",
      feature_writing: "Assistant rédaction",
      feature_writing_desc: "Suggestions contextuelles pour guider l'alternant dans ses activités.",
      feature_activity_skills: "Activité/Compétences",
      feature_activity_skills_desc: "Identifie les compétences RNCP mobilisées et évalue le niveau atteint.",
      profile_rp: "RP",
      profile_admin: "Admin",
      profile_apprentice: "Alternant",
      profile_tutor: "Tuteur",
    },
  },
};
